const Routes = {
  home: '/',
  aboutMe: '/aboutMe',
  blog: '/blog',
  blogposts: {
    siewdai: '/blog/siewdai',
    sightwords: '/blog/sightwords',
  },
  notFound: '/404',
};

export default Routes;
